import React from "react";

const TemplatesNotesBlogComp = ({ header, title, para }) => {
   return (
      <div className="vtwo-center-flex vtwo-blog-width">
         <div>
            <div className="vtwo-header-text">{header}</div>
            <div className="vtwo-title-text vtwo-text-margin ">{title}</div>
            <div className="vtwo-para-text vtwo-text-margin ">{para}</div>
         </div>
      </div>
   );
};

export default TemplatesNotesBlogComp;
